import React from 'react'

const InfluxDataLogo = (): JSX.Element => (
  <svg
    version="1.1"
    id="InfluxData_Complete_Logo"
    x="0px"
    y="0px"
    viewBox="-265.5 211 1080 220"
    className="influx-logo"
  >
    <path
      id="Cuboctahedron"
      className="st0"
      d="M-52.1,341.6l-19.1-83.1c-1.1-4.6-5.2-9.1-9.8-10.4l-87.2-26.9c-1.1-0.4-2.4-0.4-3.7-0.4
	c-3.7,0-7.6,1.5-10.2,3.7l-62.5,58.1c-3.5,3-5.2,9.1-4.1,13.5l20.4,88.9c1.1,4.6,5.2,9.1,9.8,10.4l81.6,25.4
	c1.1,0.4,2.4,0.4,3.7,0.4c3.7,0,7.6-1.5,10.2-3.7l66.8-62C-52.8,352-51,346.2-52.1,341.6z M-159.1,240.9l59.9,18.4
	c2.4,0.7,2.4,1.7,0,2.4l-31.5,7.2c-2.4,0.7-5.6-0.4-7.4-2.2l-21.9-23.6C-161.9,241.2-161.5,240.3-159.1,240.9z M-121.8,348.3
	c0.7,2.4-0.9,3.7-3.3,3l-64.6-20c-2.4-0.7-2.8-2.6-1.1-4.3l49.5-46c1.7-1.7,3.7-1.1,4.3,1.3L-121.8,348.3z M-228.3,289.8l52.5-48.8
	c1.7-1.7,4.6-1.5,6.3,0.2l26.2,28.4c1.7,1.7,1.5,4.6-0.2,6.3l-52.5,48.8c-1.7,1.7-4.6,1.5-6.3-0.2l-26.2-28.4
	C-230.2,294.1-230,291.3-228.3,289.8z M-215.5,367.2l-13.9-61c-0.7-2.4,0.4-2.8,2-1.1l21.9,23.6c1.7,1.7,2.4,5.2,1.7,7.6l-9.5,30.8
	C-214,369.6-215.1,369.6-215.5,367.2z M-138.7,403l-68.6-21.3c-2.4-0.7-3.7-3.3-3-5.6l11.5-36.9c0.7-2.4,3.3-3.7,5.6-3l68.6,21
	c2.4,0.7,3.7,3.3,3,5.6l-11.5,36.9C-133.9,402.1-136.3,403.4-138.7,403z M-77.9,353.1l-45.8,42.5c-1.7,1.7-2.6,1.1-2-1.3l9.5-30.8
	c0.7-2.4,3.3-4.8,5.6-5.2l31.5-7.2C-76.6,350.3-76.2,351.4-77.9,353.1z M-73,343.8l-37.7,8.7c-2.4,0.7-4.8-0.9-5.4-3.3l-16.1-69.9
	c-0.7-2.4,0.9-4.8,3.3-5.4l37.7-8.7c2.4-0.7,4.8,0.9,5.4,3.3l16.1,69.9C-69.1,341-70.6,343.3-73,343.8z"
    />
    <g id="Type">
      <path
        className="st0"
        d="M511.9,370.9c-0.2,2.2,0.7,2.6,1.5,2.6h5.2c2,0,2.4-1.7,2.4-2.6l21.3-120.8c0.4-2.2-1.1-2.6-2.2-2.4l0,0
		l-5.6,0.9c-1.5,0.2-2.4,1.5-2.4,2.4l0,0l-6.1,35.1c-5.4-1.7-15.6-2.8-21.5-2.8c-22.6,0-33.4,8.7-37.5,32.8l-6.7,38
		c-0.4,2.4-0.7,4.6-0.7,6.5c0,10.8,6.1,15,17.4,15c12.8,0,26-6.1,36.2-14.8L511.9,370.9z M478.1,366.3c-5.4,0-8.2-1.5-8.2-7.2
		c0-1.5,0.2-3,0.7-5.2l6.3-36.2c3.5-19.7,10.2-25.4,26.5-25.4c7.2,0,14.1,1.1,21.3,2.8l-9.5,53.6C503.4,359,489.3,366.3,478.1,366.3
		z"
      />
      <path
        className="st0"
        d="M601.7,370.9c-0.2,2.2,0.7,2.6,1.7,2.6h5.2c2,0,2.4-1.7,2.4-2.6l0,0l14.5-81.8c-10.4-3.9-22.3-5.9-30.6-5.9
		c-23.9,0-33.4,9.5-37.5,32.8l-6.7,38c-0.4,2.4-0.7,4.6-0.7,6.5c0,10.8,6.1,15,17.4,15c12.8,0,25.4-6.1,35.6-14.8L601.7,370.9z
		 M568.3,366.3c-5.4,0-8.2-1.5-8.2-7.2c0-1.5,0.2-3,0.7-5.2l6.3-36.2c3.5-19.5,9.8-25.4,26.5-25.4c7.4,0,15.8,1.5,20.8,2.8
		l-9.5,53.6C593.3,359,579.4,366.3,568.3,366.3z"
      />
      <path
        className="st0"
        d="M746.9,370.9c-0.2,2.2,0.7,2.6,1.5,2.6h5.2c2,0,2.4-1.7,2.4-2.6l0,0l14.5-81.8c-10.4-3.9-22.3-5.9-30.6-5.9
		c-23.9,0-33.4,9.5-37.5,32.8l-6.7,38c-0.4,2.4-0.7,4.6-0.7,6.5c0,10.8,6.1,15,17.4,15c12.8,0,25.4-6.1,35.6-14.8L746.9,370.9z
		 M713.7,366.3c-5.4,0-8.2-1.5-8.2-7.2c0-1.5,0.2-3,0.7-5.2l6.3-36.2c3.5-19.5,9.8-25.4,26.5-25.4c7.4,0,15.8,1.5,20.8,2.8
		l-9.5,53.6C738.6,359,724.7,366.3,713.7,366.3z"
      />
      <g>
        <path className="st0" d="M661.4,263.3L661.4,263.3L661.4,263.3z" />
        <path
          className="st0"
          d="M691.7,292.4L691.7,292.4l1.3-5.9c0.4-1.5-0.4-1.5-1.3-1.5h-24.9l3.5-20.4l0,0c0.4-2.2-1.1-2.6-2.2-2.4l0,0
			l-5.6,0.9l0,0c-1.5,0.2-2.4,1.5-2.4,2.4l0,0l-3.5,19.5h-15.4c-0.4,0-1.7,0.2-2,1.5l-0.9,5.6l0,0c0,0.4,0,1.5,1.5,1.5h15.2
			L643.4,360c-0.2,1.3-0.4,2.4-0.4,3.5c0,8,5.6,11.7,14.5,11.7c6.9,0,19.3-2,25.6-5c2-1.1,1.7-2.4,1.3-3.3l0,0l-1.3-3.5
			c-0.2-0.9-1.3-0.7-2-0.4l0,0c-6.1,2.4-9.5,3.7-21.9,3.7c-4.1,0-6.1-0.9-6.1-4.3c0-0.9,0.2-2,0.4-3.3l11.5-65.3h24.7
			C691.1,293.7,691.5,293.2,691.7,292.4z"
        />
      </g>
      <path
        className="st0"
        d="M452.7,285h-25.4c-1.1,0-2.4,0.9-3,1.7l-18,26.2l-10.6-27.3c-0.7-1.5-2-2-3.3-1.7l-22.1,3.3l19.1,42.1
		l-35.1,44.5h23.9c1.5,0,3.9-0.9,5-2.2l16.5-20l9.3,20c0.4,1.1,2,2.2,3.5,2.2h23.2l-18.7-41L452.7,285z"
      />
      <path
        className="st0"
        d="M343.3,372l15.2-86.6c0.2-1.7-1.1-1.7-2.2-1.5l-21.3,2.8c-2.4,0.4-3,2-3,2.8l0,0L323,342
		c-6.5,3.3-18.2,8.5-23,8.5c-2.6,0-3.5-0.9-3.5-2.8c0-0.7,0.2-1.7,0.4-2.8l10.4-59.7l0,0c0.2-1.7-1.1-1.7-2-1.5l-21.3,3l0,0
		c-2.4,0.4-3,2-3,2.8l0,0l-10.2,57.7c-0.7,3.7-0.9,6.5-0.9,10.2c0,11.1,4.6,18,16.3,18c10.2,0,21-3.5,34.9-10l0.2,6.5
		c0,0.4,0.2,1.5,1.1,1.5H342C342.9,373.5,343.3,372.6,343.3,372z"
      />
      <path
        className="st0"
        d="M132.7,283.3c-10.2,0-21,3.5-34.9,10l0.2-7.8c0-2-1.5-1.7-2.4-1.5l-16.7,2.8l0,0c-2.8,0.4-3.7,2.2-3.9,3
		l-13.9,79.8l0,0c-0.7,3.7-0.4,3.9,2.6,3.9h19.1c2.2,0,3.3,0,3.9-3.9l9.3-53.1c6.9-3.7,18.2-8.5,23-8.5c2.6,0,3.5,0.7,3.5,2.6
		c0,0.7-0.2,1.7-0.4,2.8l-9.8,56.2l0,0c-0.7,3.7-0.4,3.9,2.6,3.9H134c2.2,0,3.3,0,3.9-3.9l10.2-58.1c0.7-4.6,0.9-7.2,0.9-10.2
		C149,290.2,144.6,283.3,132.7,283.3z"
      />
      <g>
        <path
          className="st0"
          d="M59.2,244.6l-21.3,3c-2.4,0.2-2.8,2-3,2.8L31,272.6c-0.4,2.6-0.2,2.6,2.2,2.4l21-2.8l0,0
			c2.2-0.2,2.6-0.4,3-3.3l0,0l4.1-23C61.5,244.6,61.1,244.6,59.2,244.6z"
        />
        <path className="st0" d="M28.4,286.9L28.4,286.9L28.4,286.9z" />
        <path
          className="st0"
          d="M39.4,369.6L39.4,369.6l15-84.2c0.2-1.7-1.1-1.7-2.2-1.5L31,286.7l0,0c-2.4,0.4-3,2-3,2.8l0,0l-14.3,80.7
			c-0.4,3,0,3.5,2.8,3.5h19.1C37.5,373.5,38.5,373.5,39.4,369.6z"
        />
      </g>
      <path
        className="st0"
        d="M249.6,369.6l21.5-122.4c0.2-1.7-0.7-1.7-1.7-1.5l-24.5,4.1c-11.1-3-23.6-4.3-30.8-4.3
		c-22.8,0-30.4,7.8-34.1,28.2l-2,11.7h-10c-2.6,0-2.8,1.3-3,2.4l0,0l-3,16.9c-0.2,0.7,0.2,1.5,1.3,1.5h11.1l-11.9,67.7
		c-1.3,8-2.6,12.8-10.2,20.8l0,0c-1.5,1.5-1.1,2,0,2.8l0,0l13.5,12.6l0,0c1.3,1.3,2,1.1,3.5-0.4c12.4-12.6,16.3-21,18.4-32.8
		l12.4-70.5h19.7c1.1,0,1.3,0,1.7-1.3l0,0l4.6-17.8l0,0c0.4-1.3-0.9-1.7-1.7-1.7h-20.6l2.4-12.8c0.9-4.6,2.8-6.1,8.5-6.1
		c7.6,0,20,1.5,26.9,3.3l-17.6,100.2l0,0c-0.7,3.7-0.4,3.9,2.6,3.9h19.1C247.9,373.5,249,373.5,249.6,369.6z"
      />
    </g>
    <path
      id="Registered_Trademark"
      className="st0"
      d="M787.2,258.3h-2.4l-0.7,4.3h-2.4l2.2-12.8h4.8c2.6,0,3.9,1.1,3.9,2.8
	c0,0.2,0,0.4,0,0.9l-0.2,1.7c-0.2,1.7-0.9,2.4-2.4,3l2.4,4.6h-2.6L787.2,258.3z M790,253.5c0-0.2,0-0.4,0-0.4c0-0.9-0.4-1.1-1.5-1.1
	h-2.6l-0.7,4.3h2.6c1.5,0,1.7-0.4,2-1.5L790,253.5z M787.2,267c-6.1,0-10.8-4.8-10.8-10.8s4.8-10.8,10.8-10.8
	c6.1,0,10.8,4.8,10.8,10.8S793,267,787.2,267z M787.2,247.2c-5,0-8.9,3.9-8.9,8.9s3.9,8.9,8.9,8.9s8.9-3.9,8.9-8.9
	S791.9,247.2,787.2,247.2z"
    />
    <rect x="-265.5" y="211" className="st1" width="1080" height="220" />
  </svg>
)

export default InfluxDataLogo
